<template>
  <div role="button" class="tile-option w-36 md:w-40 inline-flex flex-col mx-3">
    <div
      class="relative"
      :class="
        isActive ? 'border-4 border-velux-red' : 'border-2 border-velux-grey-300'
      "
    >
      <slot></slot>
      <div
        class="absolute -left-1 -top-1 -bottom-1 -right-1 transition-all border-velux-red border-4 opacity-0 tile-option-border"
      ></div>
      <div
        class="absolute transition-opacity top-2.5 right-2.5 text-2xl leading-none text-velux-red opacity-0 tile-option-icon"
      >
        <div>
          <div
            class="absolute rounded-full top-1/2 left-1/2 w-9 h-9 transform -translate-x-1/2 -translate-y-1/2 bg-velux-white"
          ></div>
          <i class="fas fa-check-circle text-4xl relative z-10"></i>
        </div>
      </div>
    </div>
    <p class="mt-2 md:text-xl text-center">
      <slot name="text-below"></slot>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
@media (hover: hover) {
  .tile-option:hover .tile-option-icon,
  .tile-option:hover .tile-option-border {
    @apply opacity-100  !important;
  }
}

.tile-option:active .tile-option-icon,
.tile-option:active .tile-option-border {
  @apply opacity-100 !important;
}
</style>
